import styled from 'styled-components';
import { TitleLarge700, BodyMedium400 } from '@nebula/global-styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    flex-direction: row;
    gap: 24px;
    align-items: center;
  }
`;

export const ImageContainer = styled.div`
  flex: 0 0 auto;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    flex: 1;
  }
`;

export const StyledTitleLarge700 = styled(TitleLarge700)`
  color: ${({ theme }) => theme.color.decorative.blue[80]};
  margin: 0 0 8px 0;
`;

export const StyledHelperText = styled(BodyMedium400)`
  font-size: 16px;
  margin: 0 0 14px 0;
`;

export const StyledHelperTextContent = styled(BodyMedium400)`
  font-size: 16px;
  margin-top: 0;
`;
